//this is for global data constant variables
export const PLAN_EDIT_LIMITS = {
  freemium: 1,
  standard: 300,
  premium: 500,
};
